<template>
  <div ref="observerElement">
    <video
      ref="videoElement"
      class="video-js"
      preload="auto"
      width="640"
      height="264"
      muted
    >
      <source
        :src="source"
        type="application/x-mpegURL"
      >
    </video>
    <div
      v-if="showError"
      class="video-error"
    >
      <b-img
        src="@/assets/images/icons/no-signal1.gif"
        alt="Error image"
      > ถ้ามีภาพ
      </b-img>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import videojs from 'video.js'
import {
  BImg,
} from 'bootstrap-vue'

// eslint-disable-next-line import/no-extraneous-dependencies
require('video.js/dist/video-js.css')

export default {

  components: {
    BImg,
  },
  props: ['source'],
  data() {
    return {
      observer: null,
      showError: false, // เพิ่ม state สำหรับแสดงข้อผิดพลาด
    }
  },
  mounted() {
    this.player = videojs(this.$refs.videoElement, {}, () => {
      this.player.on('error', () => {
        this.handleError()
      })
    })
    this.setupIntersectionObserver()
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose()
    }
    if (this.observer) {
      this.observer.disconnect()
    }
  },
  methods: {
    handleError() {
      // โค้ดสำหรับจัดการเมื่อเกิดข้อผิดพลาดกับวิดีโอ
      this.showError = true // เปลี่ยน state เพื่อแสดงภาพข้อผิดพลาด
    },
    setupIntersectionObserver() {
      const options = {
        root: null, // observing with respect to viewport
        threshold: 0.5, // trigger if 50% of the player is visible
      }
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const playPromise = this.player.play()
          if (playPromise !== undefined && entry.isIntersecting) {
            // eslint-disable-next-line no-unused-vars
            playPromise.then(_ => {
              this.player.play()
            })
              .catch(error => {
                console.log(error)
              })
          } else {
            // eslint-disable-next-line no-unused-vars
            playPromise.then(_ => {
              this.player.pause()
            })
              .catch(error => {
                console.log(error)
              })
          }
        })
      }, options)
      this.observer.observe(this.$refs.observerElement)
    },
  },
}
</script>

<style scoped>
.video-js {
  width: 100%;
}
.video-error {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: black;
  display: flex;
  justify-content: center;
  align-items: center;
}
.video-error img {
  max-width: 100%;
  width: 100%;
  height: 100%;
  z-index: 1;
}
</style>
